module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAwUlEQVQokZXRoUoEUQCF4TMomtxgWhYxiEajQatxX8DuC5h9AkGTwmazxWryCWxit2kUVpAF8TM4A8NlZt394bb7weXcYIgLjJBFT7Dtrxlusb8sbPrBA46Xhe2ecILVLjjCdA6GV5xho4EVUjdMspdkt+MM6jsfSSZJbtqwqUqyVcCjJIdJVpK8J7kKBrjEPZ7x1fPcF5xifZFx4BFjVOU4XfAbdzgo1+yDn7jGTh8o4RvOsfkfaH/HWr3krJx3Xr8M2+f8AkU8EAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/contact.png
// module id = CkHa
// module chunks = 0